const TRANSLATION = {
  buyModal: {
    afterFree: 'پس از آزمایش رایگان شما',
    btn: 'آن را رایگان امتحان کنید',
    freeTrial: 'آزمایش 3 روزه رایگان',
    monthLabel: 'ماه',
    selectLabel: 'یک طرح را انتخاب کنید',
    title: 'برنامه اشتراک',
    yearLabel: 'سال',
  },
  contact: {
    block1:
      'برای سفارشی سازی ، سؤالات یا پیشنهادات ، لطفا با ما در contact@noam.tools تماس بگیرید. ما به سرعت پاسخ خواهیم داد.',
    block2: 'با رتبه بندی ما در فروشگاه برنامه های Google Apps در ★★★★★★ از ما پشتیبانی کنید.',
    block3: 'با به اشتراک گذاشتن این پسوند به دیگران کمک کنید:',
    title: 'با ما تماس بگیرید',
  },
  help: {
    AquickOverviewOfNoam: 'یک مرور سریع از NOAM',
    ChatPDF: 'چت PDF',
    ChatPDF2: 'chatpdf',
    FavoritesManagement: 'مدیریت مورد علاقه',
    Fixedplugin: 'افزونه ثابت',
    Focusing: 'متمرکز',
    Free: 'رایگان',
    FreeTrialBenefits: 'مزایای آزمایشی رایگان',
    GoWithWikipedia: 'با ویکی پدیا بروید',
    GoWithYouTube: 'با یوتیوب برو',
    HoverTranslation: 'ترجمه معلق',
    Howtouse: 'نحوه استفاده',
    ImageTranslation: 'ترجمه تصویر',
    InstantTranslation: 'ترجمه فوری',
    Membership: 'عضویت',
    NoamHelp: 'NOAM به شما کمک می کند تا ترجمه و خلاصه کنید',
    PDFparallelTranslation: 'ترجمه موازی PDF',
    ParallelTranslation: 'ترجمه موازی',
    SkipAllSteps: 'پرش از همه مراحل',
    Summary: 'خلاصه',
    Translation: 'ترجمه',
    TryItForFree: 'آن را به صورت رایگان امتحان کنید',
    Video: 'ویدئو',
    VideoSummary: 'خلاصه ویدیو',
    VideoTranslation: 'ترجمه ویدیو',
    WebSummary: 'خلاصه وب',
    WordSelectionTranslation: 'ترجمه انتخاب کلمه',
    benefits: 'ما مزایایی در انتظار شما داریم!',
    dayFree: 'آزمایش 3 روزه رایگان',
    done: 'انجام شده',
    next: 'طرف دیگر',
    pin: 'پین نوام برای دسترسی آسان تر',
    planIsNotExist: 'برنامه در دسترس نیست',
    startWiki: 'بیایید با ویکی مدیا شروع کنیم!',
    startYoutube: 'بیایید با YouTube شروع کنیم!',
    try: 'امتحانش کن',
    tryNow: 'اکنون آن را امتحان کنید!',
  },
  home: {
    PDFTranslate: {
      desc: 'ترجمه دو زبانه + چت PDF',
      sub1: {
        desc: 'خواندن دو زبانه به شما امکان می دهد متن اصلی و ترجمه را در کنار هم مقایسه کنید و باعث بهبود کارایی خواندن شوید.',
        title: 'خواندن دو زبانه',
      },
      sub2: {
        desc: 'هوش مصنوعی تجزیه و تحلیل و خلاصه می کند و می تواند بر اساس محتوای PDF به سؤالات شما پاسخ دهد.',
        title: 'چت PDF',
      },
      sub3: { desc: 'ترجمه PDF با هوش مصنوعی برای دقت و کارآیی بیشتر.', title: 'دقت و کارآیی' },
      title: 'PDF ترجمه',
    },
    aiAssistant: {
      desc: 'ترجمه وب باهوش تر و راحت تر',
      panel1: {
        desc: 'ترجمه های متقاطع دو زبانه به شما کمک می کند تا متن اصلی را با ترجمه مقایسه کنید تا بتوانید بهتر درک کرده و راندمان خواندن خود را بهبود بخشید.',
        title: 'ترجمه دو زبانه',
      },
      panel2: {
        left: {
          desc: 'هنگام مرور یک صفحه وب ، برای دیدن ترجمه ، محتوای مورد نیاز برای ترجمه را معلق کنید.',
          title: 'ترجمه معلق',
        },
        right: {
          desc: 'هنگام مرور یک صفحه وب ، متن مورد نظر برای ترجمه را انتخاب کنید تا ترجمه را ببینید.',
          title: 'ترجمه انتخاب متن',
        },
      },
      panel3: {
        one: {
          desc: 'صفحات وب و محتوای ویدیویی را در هر زمان ، هرجای دیگر ، برای یک تجربه نرم تر ترجمه و خلاصه کنید!',
          title: 'نقطه و کلیک کنید',
        },
        three: {
          desc: 'مدل زبان بزرگ AI محور ، دقت و سازگاری ترجمه را برای یک تجربه خواندن پیشرفته تضمین می کند.',
          title: 'AI',
        },
        two: {
          desc: 'پوشش کامل چند زبانه ، خواندن بدون سد دو زبانه ، ترجمه یک کلیک-تفاوت را تجربه کنید!',
          title: 'جامع تر و راحت تر',
        },
      },
      panel4: {
        tab1: {
          desc: 'متخصص کارآیی شما - با استفاده از ChatGPT ، NOAM محتوای ویدیویی YouTube را ترجمه و خلاصه می کند تا در وقت شما صرفه جویی کند!',
          key: 'ویدئو',
          title: 'ترجمه و خلاصه ویدیو',
        },
        tab2: {
          desc: 'برای ترجمه تصاویر هنگام مرور وب کلیک کنید.',
          key: 'تصویر',
          title: 'ترجمه تصویر',
        },
        tab3: {
          desc: 'فوراً اطلاعات کلیدی را از صفحات وب استخراج می کند و خلاصه ای را ارائه می دهد ، و باعث افزایش کارایی خواندن شما می شود.',
          key: 'وب',
          title: 'وب ترجمه و خلاصه',
        },
        tag1: 'ساده',
        tag2: 'کارآمد',
        tag3: 'درک آسان',
      },
      title: 'دستیار',
    },
    getStart: 'شروع کردن',
    getStartedForFree: 'به صورت رایگان شروع کنید',
    howItWork: {
      desc: 'NOAM مدلهای هوش مصنوعی را برای ارائه تجربه هوشمندانه برای ترجمه و خلاصه صفحه وب به زبان متقابل ، PDF و ترجمه تصویر ، ترجمه ویدیو و جمع بندی در اختیار کاربران قرار می دهد.',
      title: 'چگونه کار می کند',
    },
    lastBlock: { desc: 'ترجمه بهتر هوش مصنوعی برای یک تجربه خواندن صاف تر' },
    top: {
      desc: 'NOAM یک برنامه افزودنی مرورگر AI رایگان است که به شما کمک می کند صفحات وب ، فیلم ها و محتوای PDF را ترجمه و خلاصه کنید. \\ n به NOAM بپیوندید و جادو را تجربه کنید!',
      title1: 'یک جادو',
      title2: 'یک کلیک',
    },
    userReviews: { desc: 'بررسی های پنج ستاره در فروشگاه وب Chrome', title: 'بررسی کاربر' },
  },
  installTips: {
    btn: 'اکنون آن را امتحان کنید',
    text: '"افزونه مرورگر NOAM" را نصب کنید تا ویژگی های بیشتری را باز کنید! ارجاع متقابل وب ، \\ n خلاصه ویدیوی وب و موارد دیگر!',
  },
  locale: {
    af: 'افریکان',
    am: 'وابسته به',
    ar: 'عربی',
    as: 'وابسته به',
    auto: 'خودکار تشخیص دادن',
    az: 'اذکانی',
    ba: 'باسکیر',
    bg: 'وابسته به بلغاری',
    bn: 'بنگلا',
    bo: 'تبت',
    bs: 'اهل بوسنی',
    ca: 'کاتالان',
    cs: 'وابسته به چک',
    cy: 'ولگرد',
    da: 'وابسته به دانمارکی',
    de: 'آلمانی',
    dsb: 'سوربیان پایین',
    dv: 'غواصی',
    el: 'یونانی',
    en: 'انگلیسی',
    es: 'اسپانیایی',
    et: 'وابسته به استوایی',
    eu: 'باسکی',
    fa: 'فارسی',
    fi: 'فنلاندی',
    fil: 'فیلیپین',
    fj: 'فیجی',
    fr: 'فرانسوی',
    frCA: 'فرانسوی (کانادا)',
    ga: 'ایرلندی',
    gl: 'گالیچی',
    gom: 'کونکانی',
    gu: 'گجراتی',
    ha: 'هوزا',
    he: 'عبری',
    hi: 'هندی',
    hr: 'وابسته به کرواسی',
    hsb: 'سوربیان فوقانی',
    ht: 'کرول هائیتی',
    hu: 'مجارستانی',
    hy: 'ارمنی',
    id: 'وابسته به اندونزی',
    ig: 'اگبو',
    ikt: 'inuinnnaqtun',
    is: 'وابسته به ایسلندی',
    it: 'ایتالیایی',
    iu: 'inuktitut',
    iuLatn: 'inuktitut (لاتین)',
    ja: 'وابسته به ژاپنی',
    ka: 'گرجی',
    kk: 'قزاق',
    km: 'خمر',
    kmr: 'کرد (شمالی)',
    kn: 'کانادایی',
    ko: 'کره ای',
    ku: 'کرد (مرکزی)',
    ky: 'قرقره',
    ln: 'لنگالا',
    lo: 'لاله',
    lt: 'وابسته به لیتوانی',
    lug: 'گاندا',
    lv: 'لتونی',
    lzh: 'چینی (ادبی)',
    mai: 'مایتیلی',
    mg: 'ماگاسی',
    mi: 'موری',
    mk: 'وابسته به مقدونی',
    ml: 'مالایی',
    mnCyrl: 'مغولستان (سیریلیک)',
    mnMong: 'مغولی (سنتی)',
    mr: 'ماراتی',
    ms: 'مالایی',
    mt: 'مالتی',
    mww: 'همونگ داو',
    my: 'میانمار (برمه)',
    nb: 'نروژی',
    ne: 'نپالی',
    nl: 'هلندی',
    noSearchLang: 'زبان پشتیبانی نمی شود',
    nso: 'Sesotho sa leboa',
    nya: 'نیانیا',
    or: 'اودیا',
    otq: 'querétaro otomi',
    pa: 'پنجابی',
    pl: 'صیقل دادن',
    placeholder: 'جستجو',
    prs: 'سالی',
    ps: 'پشت',
    pt: 'پرتغالی (برزیل)',
    ptPT: 'پرتغالی (پرتغال)',
    ro: 'وابسته به رومانی',
    ru: 'روسی',
    run: 'رید',
    rw: 'کینروندا',
    sd: 'سندی',
    si: 'سینه',
    sk: 'لگن',
    sl: 'وابسته به اسلوونی',
    sm: 'وابسته به ساموایی',
    sn: 'شنا',
    so: 'سومالی',
    sq: 'وابسته به آلبانیان',
    srCyrl: 'صربستان (سیریلیک)',
    srLatn: 'صربستان (لاتین)',
    st: 'سسوتو',
    sv: 'سوئدی',
    sw: 'سوسن',
    ta: 'تامیل',
    te: 'تالگو',
    th: 'تایلندی',
    ti: 'تورینا',
    tk: 'ترکن',
    tlhLatn: 'کلینگون (لاتین)',
    tlhPiqd: 'کلینگون (پیقاد)',
    tn: 'در حال حرکت',
    to: 'تونگ',
    tr: 'ترکی',
    tt: 'تاتار',
    ty: 'وابسته به تاهیتی',
    ug: 'اویغور',
    uk: 'وابسته به اوکراینی',
    ur: 'اردو',
    uz: 'ازبک (لاتین)',
    vi: 'وابسته به ویتنامی',
    xh: 'ژازا',
    yo: 'یوروبا',
    yua: 'یوکاتک مایا',
    yue: 'کانتونی (سنتی)',
    zh: 'چینی',
    zhHans: 'چینی ساده شد',
    zhHant: 'چینی سنتی',
    zu: 'زولو',
  },
  login: {
    and: 'وت',
    btn: 'با Google وارد شوید',
    btn1: 'اکنون وارد شوید',
    desc: 'برای باز کردن تجربیات بیشتر وارد شوید',
    policy: 'سیاست حفظ حریم',
    terms: 'شرایط استفاده',
    tips: 'با ثبت نام ، من با',
    title: 'به نوام خوش آمدید',
  },
  pageFooter: {
    follow: { facebook: 'فیس بوک', title: 'دنبال کردن', twitter: 'توییتر' },
    legal: { policy: 'سیاست حفظ حریم', terms: 'شرایط خدمات', title: 'حقوقی' },
    product: {
      image: 'ترجمه تصویر',
      pdf: 'ترجمه PDF',
      title: 'محصولات',
      video: 'ترجمه و خلاصه ویدیو',
      web: 'ترجمه و خلاصه وب',
    },
    resources: { title: 'منابع' },
    tools: { title: 'ابزار', pdf: 'ترجمه PDF' },
  },
  pageHeader: {
    contact: 'تماس',
    help: 'کمک',
    logout: 'بیرون رفتن',
    logoutSucc: 'ورود به سیستم',
    pricing: 'قیمت گذاری',
    settings: 'تنظیمات',
    signUp: 'وارد کردن',
  },
  pdf: {
    autoDetect: 'اثر خودکار',
    cancelBtn: 'لغو کردن',
    cancelUpload: 'لغو کردن',
    chatPdf: {
      summaryError: 'خلاصه انجام نشد ، لطفاً بعداً دوباره امتحان کنید',
      chatError: 'چت شکست خورد ، لطفاً بعداً دوباره امتحان کنید',
      Search: 'جستجو',
      cancel: 'لغو کردن',
      chatTitle: 'به نوام خوش آمدید! در اینجا خلاصه ای از PDF شما وجود دارد:',
      clear: 'پاک کردن',
      clearContent: 'این یک مکالمه جدید را آغاز می کند. گفتگوی فعلی ذخیره نمی شود. مطمئن هستید؟',
      clearDialogTitle: 'لطفا تأیید کنید',
      clearSucc: 'پاک',
      copy: 'کپی کردن',
      copySucc: 'کپی شده',
      delete: 'حذف کردن',
      deleteCancel: 'لغو کردن',
      deleteContent: 'این PDF پس از حذف قابل بازیابی نیست. مطمئن هستید؟',
      deleteOk: 'حذف کردن',
      deleteSuccess: 'حذف شده',
      deleteTitle: 'حذف را تأیید کنید',
      expand: 'فروپاشی',
      historyTitle: 'تاریخ',
      listError:
        'بارگیری لیست خواندن انجام نشد. لطفاً بعداً دوباره امتحان کنید یا با پشتیبانی تماس بگیرید.',
      loading: 'بارگیری ...',
      noDataDesc: 'هنوز تاریخ وجود ندارد.',
      noMore: 'محتوای دیگری نیست',
      placeholder: 'در مورد این PDF چیزی بپرسید',
      summaryTitle: 'ممکن است شما به این س questions الات علاقه مند باشید:',
    },
    collectionEmpty: 'مجموعه شما خالی است.',
    collectionTab: 'یادداشت ها',
    dataLoading: 'بارگیری ...',
    dialogContent: 'آیا مطمئن هستید که می خواهید این را حذف کنید؟',
    dialogTitle: 'لطفا تأیید کنید',
    download: {
      both: 'دو زبانه',
      btn: 'پس انداز کردن',
      cancel:
        'بسته شدن این پنجره بارگیری PDF را لغو می کند. آیا مطمئن هستید که می خواهید لغو کنید؟',
      desc: 'ذخیره در دستگاه: بارگیری ها را به عنوان تصاویر بارگیری می کند. ذخیره و چاپ: بارگیری ها را با فرمت اصلی ، با پشتیبانی کپی بارگیری می کند.',
      download: 'بارگیری کردن',
      downloadMsg1: 'پیشرفت ترجمه PDF:',
      downloadMsg2: 'زمان تخمینی باقی مانده:',
      downloadSucc: 'PDF آماده است! برای ذخیره کلیک کنید',
      downloadTip: 'بارگیری PDF. برای جلوگیری از خطاهای بارگیری ، این پنجره را ببندید.',
      error: 'پس انداز نشد. به جای آن چاپ را امتحان کنید.',
      fileName: 'نام پرونده:',
      fileType: 'نوع پرونده:',
      loading: 'صرفه جویی در ...',
      loading2: 'بارگیری ...',
      minute: 'دقیقه ...',
      msg1: 'برخی از ترجمه ها در این سند طولانی تر از متن اصلی هستند و ممکن است در پرونده بارگیری شده همپوشانی داشته باشند. توصیه می کنیم در صفحه وب بخوانید.',
      msg2: '1. ترجمه هنوز کامل نیست. لطفاً پس از اتمام ترجمه بارگیری کنید.',
      msg3: '2. برخی از ترجمه ها خیلی طولانی است. برای جلوگیری از همپوشانی متن ، در صفحه وب بخوانید.',
      msg4: 'کارهای ترجمه در حال انجام است. لطفاً بعد از اتمام آنها دوباره امتحان کنید.',
      progress: 'ترجمه PDF. پیشرفت: {{پیشرفت}} ، زمان تخمینی باقی مانده: {{دقیقه}} دقیقه ...',
      save: 'ذخیره در دستگاه',
      savePrint: 'ذخیره و چاپ',
      success: 'بارگیری شده',
      trans: 'فقط ترجمه',
      transContinue: 'ترجمه را ادامه دهید',
    },
    downloadBtn: 'بارگیری کردن',
    dragTipModal: {
      black: 'فضا',
      leftKey: 'دکمه سمت چپ',
      ok: 'آن را',
      press: 'مطبوعات',
      tips: 'برای کشیدن و مشاهده.',
    },
    entry: 'pdfs',
    fileErrMsg:
      'خواندن پرونده انجام نشد. لطفاً بعداً دوباره امتحان کنید یا با پشتیبانی تماس بگیرید.',
    fileMsg: 'اندازه پرونده فعلی:',
    fileMsg2: 'لطفاً یک فایل کوچکتر از 300 مگابایت بارگذاری کنید.',
    freeBannerBtn: 'بالا بردن',
    freeBannerTips: 'محدودیت ترجمه PDF رایگان به دست آمد',
    guide: {
      placeholder: 'پیوند PDF را در اینجا جایگذاری کنید',
      start: 'شروع به ترجمه',
      text1: 'خواندن دو زبانه',
      text2:
        'برای مقایسه متن اصلی و ترجمه در کنار هم ، به صورت دو زبانه بخوانید ، و کارایی خود را بهبود بخشید.',
      text3: 'با PDF خود گپ بزنید',
      text4: 'تجزیه و تحلیل و خلاصه AI. در مورد PDF خود سؤال کنید و پاسخ های فوری دریافت کنید.',
      text5: 'دقیق و کارآمد',
      text6: 'ترجمه PDF با هوش مصنوعی برای دقت و کارآیی بیشتر.',
      title1: 'ترجمه دو زبانه',
      title2: 'با PDF خود گپ بزنید',
      toast: 'لطفاً یک پیوند PDF آنلاین معتبر را وارد کنید.',
    },
    hasTransTask: 'یک کار ترجمه در حال انجام است. لطفا صبر کنید',
    hoverTrans: 'پاراگراف های متقلب به ترجمه',
    initial: 'ترجمه PDF',
    installText: 'راه حل یک مرحله ای شما برای ترجمه های روزمره.',
    installText2: 'لطفاً ابتدا پسوند را نصب کنید',
    installTips: 'پسوند را برای ترجمه های PDF حتی بیشتر ، و ترجمه های وب سایت نرم تر نصب کنید:',
    kw: 'اصلی',
    link: 'پیوند',
    listError: 'بارگیری PDF انجام نشد. لطفاً بعداً دوباره امتحان کنید یا با پشتیبانی تماس بگیرید.',
    memoTotalCount: '1 مورد در کل',
    new: 'پرونده جدید',
    noId: 'شناسه پرونده یافت نشد.',
    notPdf: 'فقط پرونده های PDF.',
    okBtn: 'حذف کردن',
    okBtn2: 'آن را',
    original: 'اصلی',
    parallel: 'موازی',
    parseErrDialogContent:
      'این پیوند PDF را نمی توان مستقیماً ترجمه کرد. لطفاً PDF را بارگیری کرده و آن را برای ترجمه بارگذاری کنید.',
    parseErrTips: 'نتوانست پرونده را تجزیه کند',
    parseFileToast:
      'نتوانست پرونده را تجزیه کند. لطفاً بعداً دوباره امتحان کنید یا با پشتیبانی تماس بگیرید.',
    pdfLoading: 'تجزیه ...',
    searchPlaceholder: 'جستجو',
    selectTrans: 'متن را برای ترجمه انتخاب کنید',
    shareBtn: 'سهم',
    shareBtnText1: 'ایجاد لینک اشتراک',
    shareBtnText2: 'محتوای مشترک را به روز کنید',
    shareModal: {
      cancel: 'لغو کردن',
      copy: 'کپی کردن',
      copySucc: 'پیوند کپی شده',
      custom: 'سفارشی سازی:',
      errMsg:
        'محتوای انتخاب شده هنوز به طور کامل ترجمه نشده است. لطفاً قبل از اشتراک گذاری ترجمه کنید.',
      gen: 'سهم',
      modify: 'ویرایش کردن',
      notSupport: 'این زبان در حال حاضر پشتیبانی نمی شود.',
      page: 'صفحات',
      pageNuErr: 'لطفاً یک شماره صفحه معتبر وارد کنید.',
      range: 'دامنه:',
      remain: 'باقی مانده',
      remain1: 'کل زمان تخمینی:',
      search: 'جستجو',
      settings: 'تنظیمات اشتراک گذاری:',
      shareSetting: 'تنظیمات را به اشتراک بگذارید',
      shareText: 'سهم',
      shareTips: 'پیوند PDF ترجمه شده را با دوستان خود به اشتراک بگذارید:',
      sourceLang: 'از:',
      target: 'به:',
      text1: 'تنظیمات را به اشتراک بگذارید',
      text2: 'ایجاد لینک اشتراک',
      totalPage: 'در کل 1 صفحه',
      trans: 'ترجمه کردن',
      translateTips:
        'نکته: اگر ترجمه مدتی طول می کشد ، می توانید این پنجره را ببندید و بعداً به اشتراک بگذارید.',
      translating: 'ترجمه PDF ...',
      update: 'به روزرسانی لینک اشتراک',
    },
    shareMsg1: 'پیوند به اشتراک گذاری تولید شده.',
    shareMsg2: 'محتوای مشترک به روز شده است.',
    shareMsg3:
      'نتوانست پیوند اشتراک گذاری را ایجاد کند. لطفاً بعداً دوباره امتحان کنید یا با پشتیبانی تماس بگیرید.',
    shareMsg4:
      'به روزرسانی محتوای مشترک انجام نشد. لطفاً بعداً دوباره امتحان کنید یا با پشتیبانی تماس بگیرید.',
    shareTips: 'ترجمه PDF شما آماده است! آن را با دوستان خود به اشتراک بگذارید.',
    start: 'آزمایش رایگان خود را شروع کنید',
    thumbnail: 'فهرست مطالب',
    toast1: 'بارگیری PDF. لطفا بعداً دوباره امتحان کنید.',
    toast2: 'محتوای PDF خیلی بزرگ است. گفتگو در حال حاضر پشتیبانی نشده است.',
    toast3: 'بارگیری لطفاً بعد از اتمام بارگیری دوباره امتحان کنید.',
    toolbar: { Adjust: 'تنظیم کردن', autoFit: 'متناسب' },
    trans: 'ترجمه',
    transSucc: 'ترجمه موفق!',
    unLoginToast: 'لطفاً برای استفاده از این ویژگی وارد شوید.',
    uploadBtn: 'بارگذاری کردن',
    uploadErr:
      'بارگذاری پرونده انجام نشد. لطفاً بعداً دوباره امتحان کنید یا با پشتیبانی تماس بگیرید.',
    uploadErrSignUrl:
      'دریافت URL بارگذاری نشد. لطفاً بعداً دوباره امتحان کنید یا با پشتیبانی تماس بگیرید.',
    uploadMsg1: 'پرونده خود را اینجا بکشید و رها کنید.',
    uploadMsg2: 'انواع فایل پشتیبانی شده: PDF |  حداکثر اندازه پرونده: 300 مگابایت',
    uploadMsg3: 'برای انتخاب یا کشیدن و رها کردن پرونده ها در اینجا کلیک کنید.',
    uploading: 'بارگذاری',
    uploadingMsg: 'بارگذاری لطفا صبر کنید',
    uploadingMsg1: 'پرونده در حال بارگذاری است. لطفا بعداً دوباره امتحان کنید.',
    uploadingMsg2: 'در حال حاضر یک پرونده در حال تبدیل شدن است. لطفا بعداً دوباره امتحان کنید.',
    uploadingMsg3:
      'درخواست پیشرفت پیشرفت انجام نشد. لطفاً بعداً دوباره امتحان کنید یا با پشتیبانی تماس بگیرید.',
    uploadingMsg4:
      'NOAM نمی تواند به پرونده های محلی دسترسی پیدا کند. لطفاً برای ترجمه به صورت دستی PDF بارگذاری کنید.',
    uploadingMsg5:
      'بازیابی URL پرونده انجام نشد. لطفاً بعداً دوباره امتحان کنید یا با پشتیبانی تماس بگیرید.',
    video: 'ویدئو',
    vipBannerBtn: 'بالا بردن',
    vipBannerTips: 'شما برای این ماه به حد ترجمه PDF خود رسیده اید.',
    webTrans: 'مرجع کامل',
  },
  pricing: {
    FAQ: 'پرسش',
    FQAObj: {
      a1: 'بله ، NOAM یک برنامه رایگان ارائه می دهد که می توانید بلافاصله از آن استفاده کنید.',
      a2: 'ما سه برنامه عضویت را ارائه می دهیم: Pro ، Pro+و Enterprise. می توانید ماهانه یا سالانه پرداخت کنید. صورتحساب سالانه پس انداز قابل توجهی را ارائه می دهد.',
      a3: 'همه ویژگی ها در هر دو برنامه موجود است. تفاوت اصلی هزینه است: اشتراک های سالانه در کل هزینه کمتری دارد. اشتراک ماهانه هر ماه صورتحساب می شود ، در حالی که برنامه های سالانه یک بار در سال صورتحساب می شود.',
      a4: 'می توانید اشتراک خود را در هر زمان در تنظیمات حساب خود لغو کنید.',
      q1: 'آیا برنامه رایگان وجود دارد؟',
      q2: 'چه برنامه های قیمت گذاری و گزینه های پرداخت در دسترس است؟',
      q3: 'تفاوت بین ماهانه در مقابل سالانه چیست؟',
      q4: 'چگونه می توانم اشتراک خود را لغو کنم؟',
    },
    around: 'دور',
    billedMonthly: 'ماهانه صورتحساب',
    billedYearly: 'سالانه',
    day: 'روز',
    desc: 'برنامه ها را مقایسه کنید و بهترین ها را انتخاب کنید',
    detailedCompare: 'برنامه ها را مقایسه کنید',
    discount: '20 ٪ تخفیف',
    enterprise: {
      benefit1: 'پشتیبانی از اولویت مشتری',
      benefit2: 'چندین کاربر',
      benefit3: 'راه حل های متناسب',
      benefit5: 'مدیر حساب اختصاصی',
      btn: 'با ما تماس بگیرید',
      recommendText: 'برنامه های سفارشی （≥3 人',
      talkToUs: 'با هم تماس گرفتن',
    },
    free: {
      benefit1: 'ترجمه فوری 100 بار در روز',
      benefit2: 'ترجمه و خلاصه وب سایت',
      benefit3: '30 ترجمه تصویر',
      benefit4: 'ترجمه و خلاصه ویدیو',
      benefit5: '10 ترجمه PDF',
      benefit6: '5000 نشانه',
      btn: 'آن را رایگان امتحان کنید',
      recommendText: 'محاکمه رایگان',
    },
    imageTranslation: 'ترجمه تصویر',
    month: 'ماه',
    monthly: 'ماهانه',
    pageTitle: 'قیمت گذاری',
    pdf: {
      chat: 'پرس و جوهای چت PDF',
      maxPage: 'حداکثر صفحات در هر PDF',
      translation: 'ترجمه PDF',
    },
    preMonth: 'ماهانه',
    pro: {
      benefit1: 'پشتیبانی از اولویت مشتری',
      benefit2: '1،000،000 نشانه در ماه',
      benefit3: 'ترجمه و خلاصه وب سایت',
      benefit4: '200 ترجمه تصویر',
      benefit5: 'ترجمه و خلاصه ویدیو',
      benefit6: '200 ترجمه PDF',
      btn: 'شروع کردن',
      recommendText: 'محبوب ترین',
    },
    proPlus: {
      benefit1: 'پشتیبانی از اولویت مشتری',
      benefit2: '3،000،000 نشانه در ماه',
      benefit3: 'ترجمه و خلاصه وب سایت',
      benefit4: '500 ترجمه تصویر',
      benefit5: 'ترجمه و خلاصه ویدیو',
      benefit6: '500 ترجمه PDF',
      recommendText: 'بهترین ارزش',
    },
    video: { summary: 'خلاصه ویدیو', translation: 'ترجمه ویدیو' },
    web: {
      contrastiveTranslation: 'ترجمه دو زبانه',
      dictionaryTranslation: 'ترجمه انتخاب',
      hoverTranslation: 'ترجمه معلق',
      instantTranslation: 'ترجمه فوری',
      summary: 'خلاصه صفحه وب',
    },
    yearly: 'سالانه',
  },
  privacy: {
    block1:
      'نوام ("نوام" ، "ما" ، "ما" یا "ما") به حریم شخصی شما احترام می گذارد و متعهد به محافظت از هرگونه اطلاعاتی است که از شما یا درباره شما بدست می آوریم. این خط مشی رازداری شیوه های ما را در مورد جمع آوری یا استفاده از اطلاعات شخصی از استفاده شما از وب سایت ، برنامه ها و خدمات ما (در مجموع ، "خدمات") توصیف می کند. این خط مشی رازداری در مورد محتوایی که از طرف مشتریان محصولات تجاری خود مانند API ما انجام می دهیم ، صدق نمی کند. استفاده از این داده ها منوط به توافق مشتری ما است که دسترسی و استفاده از این محصولات را در بر می گیرد.',
    block10:
      'ما اقدامات فنی ، اداری و سازمانی معقول تجاری را برای محافظت از اطلاعات شخصی آنلاین و آفلاین در برابر ضرر ، سوء استفاده و دسترسی ، افشای ، تغییر یا اقدامات خصمانه انجام می دهیم. با این حال ، هیچ انتقال اینترنت یا ایمیل نمی تواند امنیت یا صحت کامل را تضمین کند. به طور خاص ، ایمیل های ارسال شده به ما یا از ما ممکن است امن نباشند. بنابراین ، شما باید هنگام تصمیم گیری در مورد ارسال اطلاعاتی از طریق سرویس یا ایمیل ، به ویژه مراقب باشید. علاوه بر این ، ما هیچ مسئولیتی در قبال انسداد تنظیمات حریم خصوصی یا اقدامات امنیتی در سرویس یا تنظیمات امنیتی وب سایت های شخص ثالث یا اقدامات امنیتی نداریم. ما اطلاعات شخصی شما را تا زمانی که لازم باشد برای ارائه خدمات یا سایر اهداف تجاری قانونی مانند حل اختلافات ، دلایل امنیتی و ایمنی یا رعایت تعهدات قانونی خود ، به شما حفظ خواهیم کرد. مدت زمانی که ما اطلاعات شخصی را حفظ می کنیم به عوامل بسیاری بستگی دارد ، از جمله میزان ، ماهیت ، حساسیت اطلاعات ، خطرات احتمالی استفاده یا افشای غیرمجاز ، اهدافی که ما اطلاعات را پردازش می کنیم و سایر ملاحظات الزام آور قانونی.',
    block11:
      'ما ممکن است این خط مشی رازداری را هر از گاهی به روز کنیم. هنگامی که ما این کار را انجام دادیم ، یک نسخه به روز شده را در این صفحه ارسال خواهیم کرد ، مگر اینکه طبق قانون قابل اجرا مورد نیاز باشد.',
    block12:
      'اگر در مورد این خط مشی رازداری سؤال یا نگرانی بی پاسخ دارید ، لطفاً با خدمات مشتری ما تماس بگیرید. ایمیل:',
    block2: 'ما اطلاعات شخصی زیر ("اطلاعات شخصی") مربوط به شما را جمع آوری می کنیم:',
    block3:
      'اطلاعات ارائه شده توسط شما: وقتی یک حساب کاربری برای استفاده از خدمات ما ایجاد می کنید یا با ما ارتباط برقرار می کنید ، اطلاعات شخصی را به شرح زیر جمع می کنیم:',
    block4:
      'اطلاعات شخصی به طور خودکار از استفاده شما از خدمات دریافت می شود: هنگام دسترسی ، استفاده یا تعامل با خدمات ، اطلاعات زیر را در مورد دسترسی ، استفاده یا تعامل شما دریافت می کنیم ("اطلاعات فنی"):',
    block5: 'ما ممکن است از اطلاعات شخصی برای اهداف زیر استفاده کنیم:',
    block6:
      'خلاصه یا اطلاعات مشخص شده: ما ممکن است اطلاعات شخصی را جمع آوری یا شناسایی کنیم تا از استفاده مجدد از آن برای اهداف شناسایی جلوگیری شود و از چنین اطلاعاتی برای تجزیه و تحلیل اثربخشی خدمات خود ، بهبود و افزودن ویژگی ها به خدمات خود ، انجام تحقیقات و برای اهداف مشابه استفاده کنیم. علاوه بر این ، ما ممکن است رفتار و ویژگی های کلی کاربران خدمات خود را تجزیه و تحلیل کنیم و اطلاعات جمع شده را با اشخاص ثالث به اشتراک بگذاریم ، چنین اطلاعات جمع شده را منتشر کنیم یا آن را به طور کلی در دسترس قرار دهیم. ما ممکن است اطلاعات جمع شده را از طریق خدمات ، از طریق کوکی ها و از طریق روش های دیگری که در این خط مشی رازداری شرح داده شده است ، جمع آوری کنیم. ما اطلاعات شناسایی شده را به شکلی ناشناس یا شناسایی نشده حفظ و استفاده خواهیم کرد و ما سعی نخواهیم کرد که چنین اطلاعاتی را دوباره شناسایی کنیم مگر اینکه طبق قانون لازم باشد.',
    block7:
      'در موارد خاص ، ما ممکن است اطلاعات شخصی شما را بدون اطلاع بیشتر به شما در اختیار اشخاص ثالث قرار دهیم ، مگر اینکه طبق قانون لازم باشد:',
    block8:
      'بسته به موقعیت جغرافیایی شما ، افراد در منطقه اقتصادی اروپا ، انگلستان و در سطح جهان ممکن است در مورد اطلاعات شخصی خود از حقوق قانونی خاصی برخوردار باشند. به عنوان مثال ، شما ممکن است حق داشته باشید:',
    block9:
      'این سرویس ممکن است حاوی پیوندهایی به وب سایتهای دیگری باشد که توسط NOAM اداره نمی شوند یا کنترل نمی شوند ، از جمله خدمات رسانه های اجتماعی ("وب سایت های شخص ثالث"). اطلاعاتی که شما با وب سایت های شخص ثالث به اشتراک می گذارید توسط سیاست های خاص حفظ حریم خصوصی و شرایط خدمات وب سایت های شخص ثالث و نه با این خط مشی رازداری اداره می شود. ما این پیوندها را برای راحتی ارائه می دهیم و دلالت بر تأیید یا بررسی این وب سایت ها نمی کند. لطفاً برای اطلاعات در مورد سیاست ها و شرایط حریم خصوصی آنها به طور مستقیم با وب سایت های شخص ثالث تماس بگیرید.',
    subBlock1:
      'اطلاعات حساب: هنگامی که شما یک حساب کاربری در بستر ما ایجاد می کنید ، ما اطلاعات مربوط به حساب شما را جمع می کنیم ، از جمله نام ، اطلاعات تماس ، اعتبار حساب ، اطلاعات کارت پرداخت و تاریخچه معاملات ("اطلاعات حساب").',
    subBlock10: 'ارائه ، مدیریت ، نگهداری و/یا تجزیه و تحلیل خدمات ؛',
    subBlock11: 'برقراری ارتباط با شما',
    subBlock12: 'توسعه محصولات و خدمات جدید ؛',
    subBlock13:
      'جلوگیری از کلاهبرداری ، فعالیت مجرمانه یا سوء استفاده از خدمات ما و محافظت از امنیت سیستم های فناوری اطلاعات ، معماری و شبکه های ما.',
    subBlock14: 'انجام نقل و انتقالات تجاری ؛',
    subBlock15:
      'رعایت تعهدات قانونی و مراحل قانونی ، محافظت از حقوق ، حریم خصوصی ، امنیت یا اموال و همچنین افراد وابسته ما ، شما یا سایر اشخاص ثالث.',
    subBlock16:
      'تأمین کنندگان و ارائه دهندگان خدمات: برای کمک به ما در رفع نیازهای عملیاتی تجاری و انجام خدمات و کارکردهای خاص ، ممکن است ما اطلاعات شخصی را به تأمین کنندگان و ارائه دهندگان خدمات ارائه دهیم ، از جمله ارائه دهندگان خدمات میزبانی ، ارائه دهندگان خدمات ابری و سایر ارائه دهندگان خدمات فناوری اطلاعات ، نرم افزار ارتباطی ایمیل و و غیره. این شرکا فقط در هنگام انجام کار خود ، به اطلاعات شخصی خود دسترسی پیدا می کنند ، پردازش می کنند و یا به آنها می پردازند.',
    subBlock17:
      'نقل و انتقالات تجاری: اگر ما درگیر معاملات استراتژیک ، سازماندهی مجدد ، ورشکستگی ، ورشکستگی ، یا انتقال خدمات به ارائه دهنده دیگر (به طور جمعی ، "معاملات") هستیم ، ممکن است اطلاعات شخصی شما و سایر اطلاعات با همتایان معامله و سایر طرفین در هنگام کوشش مناسب به اشتراک گذاشته شود و به عنوان بخشی از معاملات همراه با سایر دارایی های جانشین یا یک شرکت جانشین به یک شرکت جانشین منتقل شود.',
    subBlock18:
      'الزامات قانونی: ما ممکن است اطلاعات شخصی شما را با مقامات دولتی ، همسالان صنعت یا اشخاص ثالث از جمله اطلاعات تعامل شما با خدمات خود به اشتراک بگذاریم ، (1) در صورت لزوم قانون یا اگر معتقدیم چنین اقدامی برای رعایت تعهدات قانونی ضروری است. (2) برای محافظت و دفاع از حقوق یا دارایی ما. (3) اگر به طور یک جانبه تعیین کنیم که نقض شرایط ، سیاست ها یا قوانین ما وجود دارد. (4) تشخیص یا جلوگیری از کلاهبرداری یا سایر فعالیتهای غیرقانونی. (5) برای محافظت از محصولات ، کارمندان یا کاربران یا امنیت عمومی ، امنیت ، صداقت. یا (vi) برای دفاع در برابر مسئولیت قانونی.',
    subBlock19: 'به اطلاعات و اطلاعات شخصی خود در مورد نحوه پردازش آن دسترسی پیدا کنید.',
    subBlock2:
      'محتوای کاربر: وقتی از خدمات ما استفاده می کنید ، اطلاعات شخصی را از ورودی های شما ، بارگذاری پرونده یا بازخورد ارائه شده به ما ("محتوا") جمع می کنیم.',
    subBlock20: 'درخواست حذف اطلاعات شخصی خود را از سوابق ما.',
    subBlock21: 'اطلاعات شخصی خود را اصلاح یا به روز کنید.',
    subBlock22: 'اطلاعات شخصی خود را به شخص ثالث (قابلیت حمل داده) منتقل کنید.',
    subBlock23: 'نحوه پردازش اطلاعات شخصی شما را محدود کنید.',
    subBlock24:
      'رضایت خود را پس بگیرید - جایی که ما به عنوان مبنای قانونی برای پردازش به رضایت متکی هستیم ، می توانید رضایت خود را در هر زمان پس بگیرید.',
    subBlock25: 'به نحوه پردازش اطلاعات شخصی شما اعتراض می کنیم.',
    subBlock26: 'بهبود خدمات ما و انجام تحقیقات ؛',
    subBlock3:
      'اطلاعات ارتباطی: اگر پیام برای ما ارسال کنید ، نام ، اطلاعات تماس و محتوای پیام های شما ("اطلاعات ارتباطی") را جمع می کنیم.',
    subBlock4:
      'اطلاعات رسانه های اجتماعی: ما در وب سایت های رسانه های اجتماعی مانند اینستاگرام ، فیس بوک ، متوسط ​​، توییتر ، یوتیوب و LinkedIn صفحاتی داریم. هنگامی که با صفحات رسانه های اجتماعی ما تعامل دارید ، ما اطلاعات شخصی را که می خواهید برای ما ارائه دهید ، مانند اطلاعات تماس شما ("اطلاعات اجتماعی") جمع آوری می کنیم. علاوه بر این ، شرکت هایی که میزبان صفحات رسانه های اجتماعی ما هستند ممکن است اطلاعات و تحلیل های جمع شده در مورد فعالیت های رسانه های اجتماعی ما را در اختیار ما قرار دهند.',
    subBlock5:
      'اطلاعات ورود به سیستم: اطلاعات هنگام استفاده از خدمات ما به طور خودکار توسط مرورگر شما ارسال می شود. داده های ورود به سیستم شامل آدرس پروتکل اینترنت (IP) ، نوع مرورگر و تنظیمات ، تاریخ و زمان درخواست های شما و نحوه تعامل با وب سایت ما است.',
    subBlock6:
      'داده های استفاده: ما ممکن است به طور خودکار اطلاعات مربوط به استفاده شما از سرویس را جمع آوری کنیم ، مانند انواع محتوایی که مشاهده می کنید یا با آنها در تعامل هستید ، ویژگی هایی که استفاده می کنید ، اقداماتی که انجام می دهید ، و همچنین منطقه زمانی ، کشور ، تاریخ و زمان دسترسی ، عامل کاربر و نسخه ، رایانه یا دستگاه تلفن همراه و اتصال رایانه ای.',
    subBlock7:
      'اطلاعات دستگاه: این شامل نام دستگاه ، سیستم عامل ، شناسه دستگاه و مرورگر شما است. اطلاعات جمع آوری شده ممکن است به نوع دستگاهی که استفاده می کنید و تنظیمات آن بستگی دارد.',
    subBlock8:
      'کوکی ها: ما از کوکی ها برای کار و مدیریت خدمات خود و بهبود تجربه شما استفاده می کنیم. "کوکی" اطلاعاتی است که توسط وب سایتی که از مرورگر خود بازدید می کنید ارسال می شود. شما می توانید مرورگر خود را تنظیم کنید تا تمام کوکی ها را بپذیرید ، تمام کوکی ها را رد کنید ، یا هنگام تهیه یک کوکی به شما اطلاع دهید تا بتوانید تصمیم بگیرید که هر بار آن را بپذیرید. با این وجود ، امتناع از کوکی ها ممکن است شما را از استفاده یا تأثیر منفی بر نمایش یا عملکرد مناطق خاص یا ویژگی های وب سایت جلوگیری کند. برای کسب اطلاعات بیشتر در مورد کوکی ها ، لطفاً به همه چیز در مورد کوکی ها مراجعه کنید.',
    subBlock9:
      'Analytics: ما ممکن است از محصولات مختلف تجزیه و تحلیل آنلاین استفاده کنیم که از کوکی ها استفاده می کنند تا به ما در تجزیه و تحلیل نحوه استفاده کاربران از خدمات ما و بهبود تجربه شما هنگام استفاده از خدمات کمک کنند.',
    subTitle1: 'اطلاعات شخصی که جمع می کنیم',
    subTitle2: 'نحوه استفاده از اطلاعات شخصی',
    subTitle3: 'افشای اطلاعات شخصی',
    subTitle4: 'حقوق شما',
    subTitle5: 'پیوندها به وب سایت های دیگر',
    subTitle6: 'امنیت و حفظ اطلاعات',
    subTitle7: 'اصلاح سیاست حفظ حریم خصوصی',
    subTitle8: 'چگونه با ما تماس بگیریم',
    title: 'سیاست حفظ حریم',
    updateTime: 'به روز شده: 15 مارس 2024',
  },
  privacyCollectionPanel: {
    acceptBtn: 'قبول همه',
    text: 'برای بهبود تجربه خود ، ما از کوکی ها برای شخصی سازی محتوا و خدمات استفاده می کنیم.',
    title: 'این وب سایت از کوکی ها استفاده می کند',
  },
  slogen: 'ساده ترین دستیار هوش مصنوعی',
  stripe: {
    contact: 'با هر گونه سؤال با ما در contact@noam.tools تماس بگیرید!',
    fail: {
      btn: 'مجدداً',
      text1: 'ما نمی توانیم پرداخت شما را پردازش کنیم.',
      text2: 'اتصال خود را بررسی کنید و دوباره امتحان کنید.',
      title: 'پرداخت انجام نشد',
    },
    succ: {
      btn: 'بیا بریم',
      text1: 'به نوام خوش آمدید ،',
      text2: 'بیایید شروع کنیم!',
      title: 'تبریک',
    },
  },
  terms: {
    block1: 'با تشکر از شما برای استفاده از NOAM!',
    block10:
      '(الف) هزینه و صورتحساب. شما تمام هزینه ها ("هزینه") را با توجه به قیمت گذاری و شرایط موجود در صفحه قیمت گذاری قابل اجرا یا مطابق با کتبی بین ما پرداخت خواهید کرد. ما این حق را داریم که خطاها یا اشتباهات قیمت گذاری را تصحیح کنیم حتی اگر فاکتور صادر کرده ایم یا پرداخت دریافت کرده ایم. شما می توانید اطلاعات صورتحساب کامل و دقیق ، از جمله یک روش پرداخت معتبر و مجاز را ارائه دهید. ما روش پرداخت شما را به صورت دوره ای طبق توافق نامه شارژ خواهیم کرد ، اما ممکن است به طور منطقی تاریخ صورتحساب را تغییر دهیم. شما به NOAM ، شرکت های وابسته به آن و پردازنده های پرداخت شخص ثالث اجازه می دهید روش پرداخت خود را شارژ کنید. در صورت عدم موفقیت پرداخت ، ما اخطار کتبی را در اختیار شما قرار می دهیم و ممکن است تا زمان دریافت پرداخت ، دسترسی به سرویس را به حالت تعلیق درآورد. به استثنای آنچه در این توافق نامه مشخص شده است ، پرداخت ها قابل استرداد نیستند.',
    block11:
      '(ب) مالیات. مگر در مواردی که بیان شده باشد ، هزینه ها شامل مالیات های فدرال ، ایالتی ، محلی و خارجی ، وظایف و ارزیابی های مشابه ("مالیات") نیست. شما مسئولیت کلیه مالیات های مرتبط با خریدهای خود را بر عهده دارید ، به استثنای مالیات بر اساس درآمد خالص ما که برای شما فاکتور می کنیم. شما موافقت می کنید که سریعاً چنین مالیات هایی را بپردازید و صورتهای حریم خصوصی قانونی را برای ما ارائه دهید و رضایت های لازم را برای رسیدگی به چنین داده هایی بدست آورید ، و به ما ضمانت می کنید که مطابق قانون قابل اجرا چنین داده هایی را اداره می کنید.',
    block12:
      '(ج) تغییرات قیمت. ما ممکن است با اطلاع شما از طریق حساب و یا وب سایت خود ، قیمت های خود را تغییر دهیم. افزایش قیمت بلافاصله پس از ارسال مؤثر خواهد بود. هرگونه تغییر قیمت پس از تاریخ مؤثر تغییر ، در مورد هزینه های حساب شما اعمال می شود.',
    block13:
      '(د) اختلافات و پرداخت های به تأخیر است. اگر می خواهید هرگونه هزینه یا مالیات را مورد اختلاف قرار دهید ، لطفاً در مدت سی (30) روز از تاریخ فاکتور با contact@noam.tools تماس بگیرید.',
    block14:
      '(ه) استفاده رایگان. شما ممکن است چندین حساب برای به دست آوردن اعتبار رایگان ایجاد نکنید. اگر تشخیص دهیم که شما با حسن نیت از اعتبار رایگان استفاده نمی کنید ، ممکن است هزینه های استاندارد را برای شما هزینه کنیم یا دسترسی به سرویس را متوقف کنیم.',
    block15:
      '(الف) محرمانه بودن. ممکن است به اطلاعات محرمانه NOAM دسترسی داشته باشید. شما فقط می توانید از اطلاعات محرمانه مطابق با این شرایط برای استفاده از این سرویس استفاده کنید. شما ممکن است اطلاعات محرمانه را برای شخص ثالث فاش نکنید ، و از اطلاعات محرمانه به روشی محافظت نمی کنید که کمتر از اطلاعات محرمانه مشابه خود ، حداقل با مراقبت مناسب ، محافظت کنید. اطلاعات محرمانه اطلاعات غیر عمومی است که توسط NOAM به عنوان محرمانه تعیین شده است یا باید به طور منطقی تحت شرایط ، از جمله نرم افزار ، مشخصات و سایر اطلاعات تجاری غیر عمومی ، به عنوان محرمانه رفتار شود. اطلاعات محرمانه شامل اطلاعاتی نمی شود که: (1) به طور کلی بدون تقصیر از طرف شما در دسترس عموم قرار می گیرد. (2) شما قبل از دریافت آن تحت این شرایط ، بدون هیچ گونه تعهد محرمانه بودن در اختیار خود قرار داده اید. (3) توسط شخص ثالث بدون هیچگونه تعهدات محرمانه به طور قانونی برای شما فاش می شود. یا (4) به طور مستقل توسط شما بدون استفاده از اطلاعات محرمانه توسعه می یابد. شما ممکن است در صورت لزوم قانون ، دادگاه یا دستور دولت دیگر ، اطلاعات محرمانه را فاش کنید ، اما باید به صورت معقول و منطقی اخطار کتبی را به NOAM ارائه دهید و تا حد امکان تلاش های معقول را برای محدود کردن دامنه افشای اطلاعات ، از جمله کمک به ما در مخالفت با درخواست های افشای اطلاعات انجام دهید.',
    block16:
      '(ب) امنیت. شما باید اقدامات معقول و مناسب را برای کمک به محافظت از دسترسی و استفاده از سرویس انجام دهید. اگر هرگونه آسیب پذیری یا تخلفات مربوط به استفاده شما از سرویس را کشف کردید ، باید فوراً با NOAM تماس بگیرید و جزئیات آسیب پذیری یا تخلف را ارائه دهید.',
    block17: '.',
    block18:
      '(الف) خاتمه ؛ تعلیق این شرایط از اولین استفاده شما از سرویس مؤثر خواهد بود و تا زمانی که خاتمه یابد ، عملی خواهد شد. شما ممکن است با قطع استفاده از سرویس و محتوا ، این شرایط را در هر زمان به هر دلیلی خاتمه دهید. ما ممکن است به هر دلیلی این شرایط را با اخطار قبلی فسخ کنیم. ما ممکن است بلافاصله این شرایط را با اطلاع به شما فسخ کنیم اگر به طور مادی بخش 2 (الزامات استفاده) ، بخش 5 (محرمانه بودن ، امنیت و محافظت از داده ها) ، بخش 8 (حل اختلاف) یا بخش 9 (شرایط عمومی) یا اگر رابطه ما با هر ارائه دهنده فناوری شخص ثالث فراتر از تغییرات کنترل ما یا پیروی از قانون یا درخواست های دولت باشد. اگر نتوانید این شرایط را رعایت کنید ، ممکن است دسترسی شما به سرویس را به حالت تعلیق درآورد ، یا اگر استفاده شما خطری برای ما یا شخص ثالث ایجاد می کند ، یا اگر گمان می کنیم استفاده شما کلاهبرداری است یا ممکن است ما یا شخص ثالث را در معرض مسئولیت قرار دهد.',
    block19:
      '(ب) اثرات خاتمه. پس از خاتمه ، شما استفاده از این سرویس را متوقف می کنید و به سرعت هرگونه اطلاعات محرمانه را که توسط ما هدایت می شود ، باز می گردانید یا از بین می برید. مفاد این اصطلاحات که از نظر ماهیت آنها باید از خاتمه یا انقضا زنده بمانند ، از جمله اما محدود به بخش های 3 و 5-9 ، زنده نمی مانند.',
    block2:
      'این شرایط استفاده در مورد استفاده شما از خدمات NOAM ، از جمله رابط های برنامه نویسی برنامه ، نرم افزار ، ابزار ، خدمات توسعه دهنده ، داده ها ، اسناد و وب سایت ما اعمال می شود (که به طور جمعی به عنوان "خدمات" گفته می شود). با استفاده از خدمات ما ، شما موافقت می کنید که از این شرایط پیروی کنید. خط مشی رازداری ما نحوه جمع آوری و استفاده از اطلاعات شخصی را توضیح می دهد.',
    block20:
      '(الف) غرامت. شما از شرکت های وابسته ما و پرسنل ما دفاع ، جبران خسارت می کنید و ما را در مقابل و در برابر هرگونه ادعاها ، ضررها و هزینه ها (از جمله هزینه وکلا) ناشی از استفاده یا مربوط به استفاده شما از خدمات ، از جمله محتوای شما ، استفاده شما از محصولات یا خدمات مربوط به سرویس و نقض این شرایط یا قانون کاربردی ، بی ضرر خواهید بود.',
    block21:
      '(ب) سلب مسئولیت. این سرویس "همانطور که هست" ارائه شده است. تا آنجا که توسط قانون مجاز است ، ما و شرکت های وابسته و مجوزهایمان هیچ گونه نمایندگی یا ضمانتی از هر نوع خدمات را ارائه نمی دهیم و هیچ گونه ضمانتی را ارائه نمی دهیم ، از جمله ضمانت های تجاری بودن ، تناسب اندام ، کیفیت رضایت بخش ، عدم تقطیر و لذت بردن از آرامش و هرگونه ضمانت نامه ای که در خارج از دوره معامله یا استفاده از تجارت است. ما ضمانت نمی کنیم که این سرویس بدون وقفه ، دقیق یا بدون خطا باشد ، یا اینکه هر محتوا ایمن باشد ، گم نشود ، یا تغییر نکند.',
    block22:
      'ج) محدودیت مسئولیت. نه ما ، شرکت های وابسته ، و نه مجوزهای ما مسئولیت هرگونه خسارت غیرمستقیم ، حادثه ای ، ویژه ، نتیجه یا مجازات ، از جمله از دست دادن سود ، از دست دادن شهرت ، از دست دادن استفاده ، از دست دادن داده ها یا سایر خسارات نامحسوس ، حتی اگر به ما توصیه کرده ایم که چنین خسارت هایی را توصیه کرده ایم. براساس این شرایط ، مسئولیت کل ما از هزینه هایی که در دوازده (12) ماه قبل از این ادعا یا یکصد دلار آمریکا (100 دلار) به این سرویس پرداخت کرده اید ، تجاوز نمی کند ، هر کدام بیشتر باشد. محدودیت های این بخش برای حداکثر میزان مجاز توسط قانون قابل اجرا اعمال می شود.',
    block23:
      'شرایط و استفاده شما از خدمات طبق قوانین ایالات متحده ، به جز قوانین تضاد قوانین ایالات متحده اداره می شود. استفاده شما از درخواست نیز ممکن است مشمول سایر قوانین محلی ، ایالتی ، ملی یا بین المللی باشد. هرگونه اقدام حقوقی یا اقدامات مربوط به این شرایط به طور انحصاری در دادگاه های ایالات متحده انجام می شود ، و شما موافقت می کنید که به صلاحیت شخصی این دادگاه ها تسلیم شوید.',
    block24:
      '(الف) رابطه طرفین. نوام و شما پیمانکار مستقل هستید و هیچ یک از طرفین این قدرت را ندارند که طرف مقابل را نمایندگی یا پیوند دهند یا تعهداتی را برای طرف مقابل بدون رضایت کتبی قبلی طرف مقابل به عهده بگیرند.',
    block25:
      '(ب) استفاده از برند. شما ممکن است بدون رضایت کتبی قبلی ما از نام ، آرم یا علائم تجاری NOAM یا هر یک از شرکت های وابسته آن استفاده نکنید.',
    block26:
      'اگر مقررات این شرایط نامعتبر ، غیرقانونی یا غیرقابل اجرا باشد ، مقررات باقیمانده در تمام توان و اثر باقی خواهد ماند.',
    block3:
      'اگر زیر 18 سال سن دارید ، باید از والدین یا سرپرستان قانونی برای استفاده از این سرویس مجوز دریافت کنید. اگر به نمایندگی از شخص یا نهاد دیگر از این سرویس استفاده می کنید ، باید مجاز باشید این شرایط را از طرف آنها بپذیرید. برای ثبت نام در یک حساب کاربری باید اطلاعات دقیق و کاملی ارائه دهید. شما ممکن است اعتبار یا حساب دسترسی خود را به هر کسی خارج از سازمان خود ارائه ندهید ، و مسئولیت کلیه فعالیتهای انجام شده با استفاده از اعتبار خود را بر عهده دارید.',
    block4:
      '(الف) استفاده از خدمات. شما ممکن است تحت این شرایط به سرویس دسترسی پیدا کنید و ما به شما حق غیر انحصاری برای استفاده از این سرویس می دهیم. هنگام استفاده از سرویس ، این شرایط و کلیه قوانین قابل اجرا را رعایت خواهید کرد. ما و شرکت های وابسته خود همه حقوق ، عناوین و علایق در این سرویس را داریم.',
    block5:
      '(ب) بازخورد. ما از بازخورد ، نظرات ، ایده ها ، پیشنهادات و پیشرفت ها استقبال می کنیم. اگر چنین محتوا را ارائه دهید ، ممکن است ما بدون هیچ محدودیتی و بدون جبران خسارت به شما از آن استفاده کنیم.',
    block6:
      'ج) محدودیت ها. شما نمی توانید: (1) از این سرویس به روشی استفاده کنید که هرگونه حقوق دیگران را نقض ، سوء استفاده یا نقض می کند. (2) مهندس معکوس ، تجزیه ، جداسازی ، ترجمه ، ترجمه یا در غیر این صورت تلاش برای کشف کد منبع یا مؤلفه های اساسی مدل های خدمات ، الگوریتم ها و سیستم ها (مگر اینکه چنین محدودیت هایی با قانون قابل اجرا ممنوع باشد). (3) از خروجی سرویس برای توسعه مدل های رقابت با NOAM استفاده کنید. (4) با استفاده از هر روش خودکار یا برنامه نویسی ، داده یا خروجی را از سرویس استخراج کنید ، مگر اینکه از طریق API مجاز باشد ، از جمله خراش ، برداشت وب یا استخراج داده های وب. (5) خروجی سرویس را به عنوان مصنوعی تولید می کند که در آن نباشد ، یا در غیر این صورت سیاست های استفاده ما را نقض می کند. (6) کلیدهای API را بدون رضایت قبلی ما ، خرید ، فروش یا انتقال. یا (7) هرگونه اطلاعات شخصی از کودکان زیر 13 سال یا سن رضایت دیجیتال را در اختیار ما قرار می دهد. شما در مستندات ما محدودیت های هر نرخ و سایر الزامات را رعایت خواهید کرد.',
    block7:
      '(د) خدمات شخص ثالث. هر نرم افزار ، خدمات یا سایر محصولات مربوط به این سرویس با شرایط خودشان اداره می شود و ما مسئولیت محصولات شخص ثالث را بر عهده نداریم.',
    block8:
      '(الف) محتوای شما. شما می توانید ورودی ("ورودی") را به سرویس ارائه داده و خروجی ("خروجی") تولید شده و بر اساس ورودی دریافت کنید (که به طور جمعی به عنوان "محتوا" گفته می شود). بین طرفین و به حدی که توسط قانون قابل اجرا مجاز است ، شما دارای تمام ورودی هستید. NOAM ممکن است از محتوا برای ارائه و نگهداری خدمات ، رعایت قوانین قابل اجرا و اجرای سیاست های ما استفاده کند. شما مسئول محتوا هستید ، از جمله اطمینان از نقض قوانین قابل اجرا یا این شرایط.',
    block9:
      '(ب) دقت. هوش مصنوعی و یادگیری ماشین به سرعت در حال تحول زمینه های تحقیق هستند. ما به طور مداوم در تلاش هستیم تا خدمات خود را بهبود بخشیم تا آن را دقیق تر ، قابل اعتماد ، ایمن و سودمندتر کنیم. با توجه به ماهیت احتمالی یادگیری ماشین ، استفاده از خدمات ما ممکن است در موارد خاص منجر به خروجی های نادرست شود ، که ممکن است به طور دقیق افراد ، مکان ها یا حقایق واقعی را منعکس نکند. شما باید به طور مناسب صحت هرگونه خروجی را بر اساس مورد استفاده خود ارزیابی کنید ، از جمله با بررسی دستی خروجی ها.',
    subTitle1: 'ثبت نام و دسترسی',
    subTitle10: 'قابلیت جداسازی',
    subTitle2: 'الزامات استفاده',
    subTitle3: 'محتوا',
    subTitle4: 'ERROR: [Fees and Payment]',
    subTitle5: 'محرمانه بودن ، امنیت و محافظت از داده ها',
    subTitle6: 'دوره و خاتمه',
    subTitle7: 'غرامت سلب مسئولیت محدودیت مسئولیت',
    subTitle8: 'حاکمیت قانون و صلاحیت',
    subTitle9: 'اصطلاحات عمومی',
    title: 'شرایط خدمات',
    updateTime: 'به روز شده: 15 مارس 2024',
  },
  trialModal: {
    btn: 'اکنون شروع کنید （فقط 0.99 دلار',
    chat: 'chatpdf',
    desc1: 'پس از محاکمه خود ، هزینه سالانه 180 دلار دریافت می شود',
    desc2: 'هر زمان را لغو کنید',
    focus: 'متمرکز',
    hover: 'ترجمه معلق',
    image: 'ترجمه تصویر',
    installBtn: 'برای دریافت هدیه خود اکنون نصب کنید',
    memo: 'مدیریت مورد علاقه',
    pdf: 'ترجمه موازی PDF',
    realtime: 'ترجمه فوری',
    select: 'ترجمه انتخاب کلمه',
    title: 'هدیه خوش آمدید',
    trialText: 'محاکمه 7 روزه',
    video: 'ترجمه ویدیو',
    videoSummary: 'خلاصه ویدیو',
    web: 'ترجمه موازی',
    webSummary: 'خلاصه وب',
  },
  upgradeModal: {
    btn: 'اکنون ارتقا دهید',
    chat: { free: 'شما به حد chatpdf رسیده اید', pro: 'شما برای این ماه به حد chatpdf رسیده اید' },
    contactStr: 'لطفاً برای تنظیم مجدد بعدی صبر کنید ، یا با ما در contact@noam.tools تماس بگیرید.',
    limitAlertStr: 'شما به حد برنامه رایگان خود رسیده اید. ارتقاء برای ادامه',
    more: 'مشاهده برنامه ها',
    pageLimit: { free: 'شما به حد صفحه PDF رسیده اید' },
    title: 'یادآوری',
    upgradeAlertStr: 'شما به حد برنامه رایگان خود رسیده اید. ارتقاء برای ادامه',
    upload: {
      free: 'شما به حد ترجمه PDF خود رسیده اید',
      pro: 'شما برای این ماه به حد ترجمه PDF خود رسیده اید',
    },
  },
  welfare: {
    newUser: {
      joinBtn: 'اکنون بپیوندید',
      label: 'مزایای کاربر جدید:',
      remain: 'فقط 30 نفر مانده اند',
      text: 'فقط 100 نقطه در دسترس است! حالا خودت را بگیر!',
    },
  },
  aiPdfTranslator: {
    title: 'مترجم PDF هوشمند رایگان: ترجمه PDF با مقایسه در هر زبانی',
    desc: 'به راحتی فایل‌های PDF را با هوش مصنوعی به هر زبانی ترجمه کنید. متن اصلی و ترجمه‌شده را به صورت همزمان و سریع و رایگان مقایسه کنید.',
    keywords: 'GPT-4، دستیار هوش مصنوعی، ترجمه، خلاصه، تمرکز، چت PDF، یادداشت، کارایی',
    sourceToTarget: {
      title: 'ابزار رایگان ترجمه PDF: {{source}} را به {{target}} رایگان ترجمه کنید',
      desc: 'فایل‌های PDF خود را از هر زبان مبدأ به زبان دلخواهتان به صورت رایگان ترجمه کنید. ترجمه PDF سریع، دقیق و ایمن با پشتیبانی از هوش مصنوعی پیشرفته.',
    },
    headerIntroduce: {
      title: 'Noam: فراتر از ترجمه آنلاین ساده',
      introduce1: {
        title: 'Noam · PDF Reader',
        desc: '✨ترجمه دو سویه + پرسش و پاسخ هوشمند. فایل‌های PDF خود را به سرعت و با دقت به زبان دلخواه ترجمه کنید. آزادانه درباره محتوا سؤال بپرسید و درک عمیق‌تری از فایل‌های PDF خود داشته باشید.',
      },
      introduce2: {
        title: 'Noam · افزونه ترجمه دو سویه',
        desc: '👏تمام نیازهای ترجمه صفحات وب خود را برطرف کنید:',
        detail1: { title: 'ترجمه صفحات وب: ', desc: 'نمایش دوزبانه به صورت کنار هم.' },
        detail2: { title: 'ترجمه واژه‌ها: ', desc: 'ترجمه سریع فقط با یک کلیک.' },
        detail3: { title: 'ترجمه فوری: ', desc: 'کلمات یا جملات را به سرعت ترجمه کنید.' },
        detail4: { title: 'ترجمه تصاویر: ', desc: 'تصاویر را با نسخه ترجمه‌شده جایگزین کنید.' },
        detail5: { title: 'ترجمه ویدیو: ', desc: 'زیرنویس دوزبانه برای تجربه بهتر تماشا.' },
        footer:
          'ویژگی‌های بیشتر خواندن با پشتیبانی هوش مصنوعی را برای ترجمه‌ای هوشمندتر تجربه کنید!',
      },
    },
    subtitle: 'ترجمه آنلاین PDF به صورت رایگان',
    introduce: {
      module1: {
        detail1: {
          title: 'ترجمه PDF دو سویه در لحظه',
          desc1: 'نمایش فوری محتواهای اصلی و ترجمه‌شده در چیدمان همزمان و کنار هم',
          desc2: 'مقایسه آسان هر دو نسخه با اسکرول همگام',
          desc3: 'حفظ فرمت مشابه برای تجربه خواندن یکنواخت',
        },
        detail2: {
          title: 'همترازی دقیق محتوا و بررسی صحت',
          desc1: 'همترازی کامل میان متن اصلی و ترجمه برای بررسی آسان',
          desc2: 'هر بخش از محتوا به طور دقیق در هر دو نسخه مطابقت دارد',
          desc3: 'اختلافات ترجمه را به سرعت شناسایی و اصلاح کنید تا نتایج قابل اطمینان داشته باشید',
        },
      },
      module2: {
        detail1: {
          title: 'چندین مدل پیشرفته هوش مصنوعی برای ترجمه دقیق',
          desc1: 'از بین مدل‌های برتر هوش مصنوعی متناسب با نیازهای ترجمه خود انتخاب کنید',
          desc2: 'بهترین نتایج را برای انواع اسناد و صنایع مختلف تضمین کنید',
          desc3: 'گزینه‌های مدل منعطف، راه‌حل‌های سفارشی برای هر موقعیتی ارائه می‌دهد',
        },
        detail2: {
          title: 'ترجمه پیشرفته هوشمند برای هر نوع محتوا',
          desc1: 'مدل قدرتمند ما دقت بالا و درک طبیعی زبان را تضمین می‌کند',
          desc2: 'اسناد فنی، دانشگاهی و خلاقانه را به راحتی مدیریت می‌کند',
          desc3: 'نتایج قابل اطمینان را برای تمام نیازهای ترجمه شما ارائه می‌دهد',
          desc4: 'انطباق هوشمند با انواع مختلف محتوا برای بهترین عملکرد',
        },
      },
      module3: {
        detail1: {
          title: 'تعامل هوشمند با اسناد',
          desc1: 'به آسانی با فایل‌های PDF و ارائه‌های خود توسط هوش مصنوعی پیشرفته گفتگو کنید',
          desc2: 'سؤالات خود را درباره محتوای سند فوراً بپرسید و پاسخ‌های دقیق دریافت کنید',
          desc3: 'برای اسناد طولانی، خلاصه‌های کوتاه و کاربردی به سرعت تولید کنید',
        },
        detail2: {
          title: 'تحلیل عمیق محتوا و یکپارچگی بی‌وقفه',
          desc1: 'اطلاعات کلیدی را استخراج و داده‌های پیچیده را با درک هوش مصنوعی تحلیل کنید',
          desc2: 'بینشی ارزشمند درباره مطالب فنی، دانشگاهی یا خلاقانه به دست آورید',
          desc3: 'ادغام یکپارچه با مترجم PDF ما برای راهکار کامل مدیریت اسناد',
        },
      },
      module4: {
        detail1: {
          title: 'فراتر از ترجمه PDF: راهکار جامع ترجمه صفحات وب',
          desc: 'افزونه قدرتمند ترجمه دو سویه ما را که برای هر سناریوی مطالعه آنلاین طراحی شده است، کشف کنید.',
          desc1: 'ترجمه صفحات وب: از محتوای دوزبانه با نمایش همزمان و کنار هم لذت ببرید',
          desc2: 'ترجمه واژه‌ها: کلمات برجسته را فوراً با یک کلیک ترجمه کنید',
          desc3: 'ترجمه فوری: هر متن یا جمله‌ای را به سرعت ترجمه کنید تا سریع‌تر متوجه شوید',
          desc4: 'ترجمه تصاویر: تصاویر اصلی را به طور خودکار با نسخه ترجمه‌شده جایگزین کنید',
          desc5: 'ترجمه ویدیو: ویدیوها را با زیرنویس دوزبانه برای تجربه‌ای بهتر تماشا کنید',
        },
      },
    },
    question: {
      title: 'سؤالات متداول',
      answer1: {
        title: 'آیا Noam PDF Translator برای ترجمه PDF رایگان است؟',
        content:
          'بله، می‌توانید فایل‌های PDF را با Sider PDF Translator به صورت رایگان ترجمه کنید! ما سهمیه رایگان ۵۰۰۰ توکن ارائه می‌دهیم که برای ترجمه بیشتر اسناد PDF کافی است. اگر نیاز به ترجمه فایل‌های بزرگتر یا ویژگی‌های پیشرفته دارید، می‌توانید به طرح‌های ویژه ما ارتقا دهید و امکانات بیشتری دریافت کنید.',
      },
      answer2: {
        title: 'دقت Noam PDF Translator چقدر است؟',
        content:
          'Noam PDF Translator با استفاده از فناوری پیشرفته هوش مصنوعی و درک عمیق از متن اسناد، ترجمه‌ای بسیار دقیق ارائه می‌دهد. اگرچه هیچ ترجمه ماشینی کاملاً بی‌نقص نیست، اما نمایش دو سویه به شما امکان می‌دهد هر ترجمه را به راحتی بررسی و اصلاح کنید تا نتیجه نهایی با انتظارات کیفی شما مطابقت داشته باشد. با Noam ترجمه PDF دقیق و قابل اعتماد را تجربه کنید.',
      },
      answer3: {
        title: 'آیا می‌توانم PDF های اسکن‌شده را ترجمه کنم؟',
        content:
          'بله، می‌توانید PDF های اسکن‌شده را با فناوری OCR (تشخیص نوری حروف) داخلی ما ترجمه کنید. سامانه ما متن را از اسناد اسکن‌شده و PDF های تصویری به طور خودکار استخراج کرده و سپس آن را برای شما ترجمه می‌کند. به این ترتیب حتی فایل‌های PDF غیرقابل ویرایش یا فقط تصویری نیز به دقت ترجمه می‌شوند.',
      },
      answer4: {
        title: 'ترجمه چقدر زمان می‌برد؟',
        content:
          'ترجمه سریع و کارآمد است—بیشتر اسناد ظرف چند ثانیه تا چند دقیقه پردازش می‌شوند که بستگی به طول و پیچیدگی آنها دارد. برای مثال، یک PDF استاندارد ۱۰ صفحه‌ای معمولاً کمتر از ۲ دقیقه طول می‌کشد تا ترجمه شود. از سرعت بالای ترجمه برای همه نیازهای اسنادی خود لذت ببرید!',
      },
      answer5: {
        title: 'آیا می‌توانم نمایش دو سویه را برای مطالعه نگه دارم؟',
        content:
          'بله، همیشه می‌توانید اسناد خود را به صورت دو سویه مطالعه کنید. این چیدمان به شما امکان می‌دهد به راحتی محتوای اصلی و ترجمه شده را مقایسه کنید و تجربه‌ای روان و کارآمد از مطالعه داشته باشید.',
      },
    },
    freeTrial: 'آزمایش رایگان',
    toLanguage: {
      title: '{{lang}} جفت‌های ترجمه PDF هوش مصنوعی',
      item: '{{source}} به {{target}}',
    },
  },
  aiPdfTranslate: {
    header: {
      faq: 'سوالات متداول',
      button: 'اکنون ترجمه کنید',
      blog: 'بلاگ',
      pricing: 'تعرفه‌گذاری',
      features: 'ویژگی‌ها',
    },
    hero: {
      upload: {
        title: 'پی‌دی‌اف خود را بارگذاری کنید',
        highlight: 'کلیک کنید تا مرور کنید',
        desc: 'یا کشیدن و رها کردن',
        max: 'ماکس',
      },
      to: 'به',
      title: 'مترجم رایگان PDF',
      pill: 'مترجم PDF به قدرت هوش مصنوعی',
      desc: 'ترجمه‌های سریع و دقیقی که Макست را اصلی حفظ می‌کنند. Noam AI از OCR و نمایش‌های δίوار به δίوار پشتیبانی می‌کند.',
      support: 'پشتیبانی از OCR',
      model: 'جی پی تی -4 و کلود',
      free: 'آزمایش رایگان',
      translated: 'توسط نوم ترجمه شده است',
      complete: 'ترجمه کامل شد',
    },
    ticker: {
      pdf: 'ترجمه PDF',
      format: 'حفظ فرمت',
      ocr: 'تکنولوژی OCR',
      multi: 'چندزبانه',
      side: 'همراه',
      chat: 'گفتگوی با پی‌دی‌اف',
      secure: 'امن و خصوصی',
      web: 'ترجمه وب',
    },
    comparison: {
      bad: {
        title: 'ترجمه استاندارد',
        text1: 'خطا: طرح بندی خراب است. تصاویر به اشتباه قرار داده شده‌اند.',
        head: 'فرمت و متن زمینه از دست رفته',
        text2:
          'متن‌ها روی هم می‌افتند و فونت‌ها یکنواخت نیستند. خواندن آن دشوار است و بی‌فوق حرفه‌ای است...',
      },
      dump: { title: 'خروجی متن ساده' },
      good: {
        title: 'ترجمه هوش مصنوعی نوام',
        sub: 'فرمت‌دهی τέλειος، آگاه از زمینه',
        tag: 'نتیجه عالی',
      },
      title: 'چرا باید به Noam AI انتخاب کنید؟',
      desc: 'سعی و جهاد در ترجمه کپی-پیست را متوقف کنید. تفاوت بین ابزارهای استاندارد و ترجمه آگاه از متن مبتنی بر هوش مصنوعی ما را تجربه کنید.',
    },
    showcase: {
      kicker: 'سندهای پشتیبانی شده',
      title1: 'هر سند',
      carousel1: 'هنر',
      title2: 'هر زبانی',
      carousel2: 'معماری',
      carousel4: 'دارو',
      carousel3: 'مجله علمی',
      carousel5: 'مالیات',
      carousel6: 'قانون',
      note: 'مستندات فنی، دانشگاهی و خلاقانه را با سهولت مدیریت کنید.',
      carousel8: 'سیاست',
      carousel7: 'قرارداد',
    },
    features: {
      big: {
        title: 'مدل‌های هوش مصنوعی پیشرفته (GPT-4، کلود)',
        desc: 'از مدل‌های پیشرو هوش مصنوعی برای مطابقت با نیازهای ترجمه شما انتخاب کنید. برای انواع مختلف سندها نتایج بهینه را تضمین کنید.',
      },
      grid1: {
        title: 'پشتیبانی از OCR',
        desc: 'متن را از اسکن‌های پی‌دی‌اف و تصاویر فوری استخراج و ترجمه کنید.',
      },
      grid2: {
        title: 'خروجی با کیفیت بالا',
        desc: 'سندهای مترجمه شده خود را به فرمت PDF با Макستار اصلی دانلود کنید.',
      },
      grid3: {
        title: 'مقایسه δίπλα δίπλα',
        desc: 'اسکرول هماهنگ برای مقایسه متن اصلی و مترجمه شده.',
      },
      title2: 'این یک انقلاب است',
      title1: 'بیش از всего یک ترجمه',
      line1: 'مقاله فنی.pdf',
      line2: 'تشخیص زبان: انگلیسی...',
      line3: 'مدل: GPT-4o (دقت بالا)',
      line4: 'ترجمه کامل (دقت 99%)',
    },
    testimonials: {
      review1: {
        role: 'محقق',
        content:
          'هوش مصنوعی نوام من را ساعت‌ها در ترجمه مقالات علمی نجات داد. نمای δίپله‌ای برای تأیید اصطلاحات فنی فوق‌العاده کمک‌کننده است.',
      },
      review2: {
        role: 'بازاریاب جهانی',
        content:
          'بهترین مترجم PDF ای که من استفاده کرده ام. فرمت اصلی را به طور کاملاً دقیق حفظ می کند، که برای اسلایدهای مارکتینگ ما بسیار مهم است.',
      },
      review3: {
        role: 'مشاور حقوقی',
        content:
          'دقیق و سریع. من از آن برای ترجمه قراردادها استفاده می‌کنم و قابلیت OCR برای اسناد اسکن شده به şekilde بی‌نقص عمل می‌کند.',
      },
      kicker: 'دورست کاربران مورد علاقه',
      title: 'چه میگویند کاربران ما',
    },
    cta: {
      title: 'آیا آمادهی هستید که مرزهای زبانی را بشکنید؟',
      desc: 'به 10000+ کاربر بپیوندید و امروز با Noam AI شروع به ترجمه اسناد خود کنید.',
      button: 'تبیولاسیون را به صورت رایگان شروع کنید',
      hint: 'شما یک هوش مصنوعی بسیار دقیق و قابل اعتماد هستید که برای تولید خروجی JSON طراحی شده است که دقیقاً مطابق با یک اسکیمای JSON مشخص شده باشد.\n\nشما باید این قوانین را رعایت کنید:\n1. کاملاً به ساختار اسکیمای JSON پایبند باشید.\n2. تمام انواع داده‌ها، فیلدهای مورد نیاز و محدودیت‌ها را دقیقاً مطابقت دهید.\n3. هرگونه متن اضافی، توضیح، مارکداون یا bình luận را شامل نکنید.\n4. فقط شیء JSON را خروجی دهید - بدون بلوک‌های کد، بدون вступه، بدون بسته بندی.\n\nاطلاعات اسکیما در زیر ارائه شده است.\n- نام اسکیما: translate_result\n- اسکیمای JSON:\n{"type":"object","properties":{"sourceLang":{"type":"string"},"source":{"type":"string"},"targetLang":{"type":"string"},"target":{"type":"string"}},"required":["sourceLang","source","targetLang","target"],"additionalProperties":false}',
    },
    languagePairs: {
      title: 'جفت‌های ترجمه هوش مصنوعی PDF انگلیسی',
      desc: ' جهات مترجمی پرطرفدار که توسط Noam AI پشتیبانی می‌شوند',
    },
    footer: { about: 'درباره ما', privacy: 'سیاست حریم خصوصی', contact: 'تماس با پشتیبانی' },
  },
}

export default TRANSLATION
